"use strict";
var Trigger_1 = require('../Trigger');
var TriggerType_1 = require('../TriggerType');
var TriggerEventType_1 = require('../TriggerEventType');
var Pop_1 = require('../Pop');
var PopEngine_1 = require('../PopEngine');
var PopChainManager_1 = require('../PopChainManager');
var TimeoutManager_1 = require('../TimeoutManager');
var closest = require('closest');
var EventDelegate = (function () {
    function EventDelegate() {
    }
    EventDelegate.prototype.init = function () {
        this._setEventListener(new Trigger_1.default(TriggerType_1.default[TriggerType_1.default['CLICK']]), this.onClick);
        this._setEventListener(new Trigger_1.default(TriggerType_1.default[TriggerType_1.default['BLUR']]), this.onBlur);
        this._setEventListener(new Trigger_1.default(TriggerType_1.default[TriggerType_1.default['FOCUS']]), this.onFocus);
        this._setEventListener(new Trigger_1.default(TriggerType_1.default[TriggerType_1.default['HOVER']]), this.onHover);
        this._setEventListener(new Trigger_1.default(TriggerType_1.default[TriggerType_1.default['MANUAL']]), this.onManual);
        this._setEventListener(new Trigger_1.default(TriggerType_1.default[TriggerType_1.default['MOUSEOUT']]), this.onMouseOut);
        PopEngine_1.default.listenForScroll();
    };
    EventDelegate.prototype.onClick = function (e) {
        var t = TriggerEventType_1.default.triggerEventTypeToTriggerType(e.type);
        var trigger = new Trigger_1.default(t);
        var target = closest(e.target, '[popgun]', true) || closest(e.target, '[pop]', true);
        var isPinned = trigger.name === TriggerType_1.default.CLICK;
        if (PopEngine_1.default.isPopForTrigger(target, trigger)) {
            if (PopEngine_1.default.isPopAlreadyOpenForTarget(target)) {
                if (target.hasAttribute('pinned-pop')) {
                    target.setAttribute('unpinned-pop', '');
                    PopEngine_1.default.hidePop(target, false);
                }
                else {
                    PopChainManager_1.default.maybePinOrUnpinPopAndParentPops(target, isPinned);
                }
            }
            else {
                this._showPop(target, trigger);
            }
        }
        else if (!PopEngine_1.default.isPopTarget(target) && !PopEngine_1.default.isPop(target)) {
            PopEngine_1.default.popTopPop();
        }
    };
    EventDelegate.prototype.onHover = function (e) {
        var t = TriggerEventType_1.default.triggerEventTypeToTriggerType(e.type);
        var trigger = new Trigger_1.default(t);
        var target = closest(e.target, '[popgun]', true) || closest(e.target, '[pop]', true);
        if (PopEngine_1.default.isPopForTrigger(target, trigger)) {
            if (PopEngine_1.default.isPopAlreadyOpenForTarget(target)) {
                var groupId = target.getAttribute('popgun-group');
                TimeoutManager_1.default.maybeClearTimeout(TimeoutManager_1.default.getTimeouts().timeToHoverOnPop, groupId);
            }
            else {
                if (!target.hasAttribute('unpinned-pop')) {
                    this._showPop(target, trigger);
                }
            }
        }
        else if (PopEngine_1.default.isPop(target)) {
            target = closest(e.target, '[pop]', true);
            var groupId = target.getAttribute('pop-id');
            var pop = PopEngine_1.default.getPopFromGroupId(groupId);
            TimeoutManager_1.default.maybeClearTimeout(TimeoutManager_1.default.getTimeouts().timeToHoverOnPop, groupId);
            this._clearParentPops(pop);
        }
    };
    EventDelegate.prototype.onBlur = function (e) {
        var t = TriggerEventType_1.default.triggerEventTypeToTriggerType('focusin');
        var trigger = new Trigger_1.default(t);
        var target = closest(e.target, '[popgun]', true);
        if (PopEngine_1.default.isPopForTrigger(target, trigger)) {
            PopEngine_1.default.hidePop(target, false);
        }
    };
    EventDelegate.prototype.onFocus = function (e) {
        var t = TriggerEventType_1.default.triggerEventTypeToTriggerType(e.type);
        var trigger = new Trigger_1.default(t);
        var target = closest(e.target, '[popgun]', true) || closest(e.target, '[pop]', true);
        if (PopEngine_1.default.isPopForTrigger(target, trigger)) {
            this._showPop(target, trigger);
        }
    };
    EventDelegate.prototype.onManual = function (e) {
        var t = TriggerEventType_1.default.triggerEventTypeToTriggerType(e.type);
        var trigger = new Trigger_1.default(t);
        var target = closest(e.target, '[popgun]', true);
        if (PopEngine_1.default.isPopForTrigger(target, trigger)) {
            this._showPop(target, trigger);
        }
    };
    EventDelegate.prototype.onMouseOut = function (e) {
        var target = closest(e.target, '[pop]', true);
        if (!!target) {
            var groupId = target.getAttribute('pop-id');
            var relatedTarget = closest(e.relatedTarget, '[pop-id="' + groupId + '"]', true);
            if (!!relatedTarget) {
                // same pop
                TimeoutManager_1.default.maybeClearTimeout(TimeoutManager_1.default.getTimeouts().timeToHoverOnPop, groupId);
                return;
            }
            else {
                relatedTarget = closest(e.relatedTarget, '[pop]', true);
                if (!!relatedTarget) {
                    // hovering into another pop
                    // ensure its not the same closest pop
                    // see if they are in the same chain..
                    var targetPop = PopEngine_1.default.getPopFromGroupId(groupId);
                    var relatedPop = PopEngine_1.default.getPopFromGroupId(relatedTarget.getAttribute('pop-id'));
                    if (!(targetPop.parentPop === relatedPop || relatedPop.parentPop === targetPop) && !targetPop.targetEl.hasAttribute('pinned-pop')) {
                        // if they arent related to each other
                        PopEngine_1.default.hidePop(targetPop.targetEl, false);
                        return;
                    }
                }
                else {
                    var pop = PopEngine_1.default.getPopFromGroupId(groupId);
                    if (PopEngine_1.default.isPopForTrigger(pop.targetEl, (new Trigger_1.default('hover'))) && !pop.targetEl.hasAttribute('pinned-pop')) {
                        // hide pop is the target is not pinned
                        pop.targetEl.removeAttribute('unpinned-pop');
                        PopEngine_1.default.hidePop(pop.targetEl, false);
                        return;
                    }
                }
            }
        }
        target = closest(e.target, '[popgun]', true);
        if (!!target) {
            var groupId = target.getAttribute('popgun-group');
            var relatedTarget = closest(e.relatedTarget, '[popgun-group="' + groupId + '"]', true);
            if (!!relatedTarget) {
                // same popgun target
                TimeoutManager_1.default.maybeClearTimeout(TimeoutManager_1.default.getTimeouts().timeToHoverOnPop, groupId);
                return;
            }
            else if (!target.hasAttribute('pinned-pop')) {
                // hovering into nothing
                // hide if pop isn't pinned
                target.removeAttribute('unpinned-pop');
                var focusTrigger = new Trigger_1.default('focus');
                if (!PopEngine_1.default.isPopForTrigger(target, focusTrigger)) {
                    PopEngine_1.default.hidePop(target, false);
                }
                return;
            }
        }
    };
    EventDelegate.prototype._clearParentPops = function (pop) {
        if (pop) {
            while (!!pop.parentPop) {
                var groupId = pop.parentPop.targetEl.getAttribute('pop-id');
                TimeoutManager_1.default.maybeClearTimeout(TimeoutManager_1.default.getTimeouts().timeToHoverOnPop, groupId);
                pop = pop.parentPop;
            }
        }
    };
    EventDelegate.prototype._showPop = function (target, trigger) {
        var pop = new Pop_1.default(target, trigger);
        var isPinned = trigger.name === TriggerType_1.default.CLICK;
        PopEngine_1.default.showPop(target, isPinned, pop);
    };
    EventDelegate.prototype._setEventListener = function (trigger, listener) {
        document.removeEventListener(trigger.eventType, listener.bind(this));
        document.addEventListener(trigger.eventType, listener.bind(this), trigger.useCapture);
    };
    return EventDelegate;
}());
exports.EventDelegate = EventDelegate;
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = new EventDelegate();
